export default __webpack_public_path__ + "static/media/img9.5e30939a.PNG";